// Angular
import { Injectable } from "@angular/core";
import { MatPaginator, MatSnackBar, MatDialog } from "@angular/material";
import { Router } from "@angular/router";
import { RemindDeliveryPlanComponent } from "app/views/partials/content/crud/remind-delivery-plan/remind-delivery-plan.component";
import { BOMImportResultComponent } from "app/views/pages/nfc/rd/bom/bom-import-result/bom-import-result.component";
// Partials for CRUD
import {
	ActionNotificationComponent,
	DeleteEntityDialogComponent,
	FetchEntityDialogComponent,
	UpdateStatusDialogComponent,
	PopUpComponent,
	PopUpHuongXuLyComponent,
} from "../../../../views/partials/content/crud";
import { KhoDeNghiXuatKhoImportWarningtComponent } from "app/views/pages/nfc/chuc-nang-kho-page/kho-de-nghi-xuat-kho-page/kho-de-nghi-xuat-kho-import-warning/kho-de-nghi-xuat-kho-import-warning.component";
import { TimePickerPopupComponent } from "app/views/partials/content/crud/time-picker-popup/time-picker-popup.component";

export enum MessageType {
	Create,
	Read,
	Update,
	Delete,
	Success,
	Info,
	Warning,
	Error,
}

@Injectable()
export class LayoutUtilsService {
	/**
	 * Service constructor
	 *
	 * @param snackBar: MatSnackBar
	 * @param dialog: MatDialog
	 */
	constructor(private snackBar: MatSnackBar, private dialog: MatDialog, private router: Router) { }

	/**
	 * Showing (Mat-Snackbar) Notification
	 *
	 * @param message: string
	 * @param type: MessageType
	 * @param duration: number
	 * @param showCloseButton: boolean
	 * @param showUndoButton: boolean
	 * @param undoButtonDuration: number
	 * @param verticalPosition: 'top' | 'bottom' = 'top'
	 */
	showActionNotification(
		_message: string,
		_type: MessageType = MessageType.Create,
		_duration: number = 10000,
		_showCloseButton: boolean = true,
		_showUndoButton: boolean = true,
		_undoButtonDuration: number = 3000,
		_verticalPosition: "bottom" | "top" = "bottom"
	) {
		const _data = {
			messsage: _message,
			snackBar: this.snackBar,
			showCloseButton: _showCloseButton,
			showUndoButton: _showUndoButton,
			undoButtonDuration: _undoButtonDuration,
			verticalPosition: _verticalPosition,
			type: _type,
			action: "Undo",
		};
		return this.snackBar.openFromComponent(ActionNotificationComponent, {
			duration: _duration,
			data: _data,
			verticalPosition: _verticalPosition,
		});
	}

	/**
	 * Showing Confirmation (Mat-Dialog) before Entity Removing
	 *
	 * @param title: stirng
	 * @param description: stirng
	 * @param waitDesciption: string
	 */
	deleteElement(
		title: string = "",
		description: string = "",
		waitDesciption: string = ""
	) {
		return this.dialog.open(DeleteEntityDialogComponent, {
			data: { title, description, waitDesciption },
			width: "440px",
		});
	}

	/**
	 * Showing Fetching Window(Mat-Dialog)
	 *
	 * @param _data: any
	 */
	fetchElements(_data) {
		return this.dialog.open(FetchEntityDialogComponent, {
			data: _data,
			width: "400px",
		});
	}

	/**
	 * Showing Update Status for Entites Window
	 *
	 * @param title: string
	 * @param statuses: string[]
	 * @param messages: string[]
	 */
	updateStatusForEntities(title, statuses, messages) {
		return this.dialog.open(UpdateStatusDialogComponent, {
			data: { title, statuses, messages },
			width: "480px",
		});
	}

	menuSelectColumns_On_Off(type: 0 | 1 = 0) {
		let v, p, _className, _style;
		v = document.querySelector("body[m-root]");
		p = document.querySelector("m-pages");
		if (v && p) {
			_className = "no-overflow";
			_style = v.attributes["style"].nodeValue;
			_style = _style.replace(/--scrollwidth.*\;/g, "");
			if (v.classList.contains(_className)) {
				//q.setAttribute("style", "--scrollwidth:0px");
				_style = "--scrollwidth:0px;" + _style;
				v.classList.remove(_className);
			} else {
				_style =
					"--scrollwidth:" +
					(window.innerWidth - v["offsetWidth"]) +
					"px;" +
					_style;
				v.classList.add(_className);
			}
			v.setAttribute("style", _style);
		}
	}

	setUpPaginationLabels(pagination: MatPaginator) {
		pagination._intl.firstPageLabel = "Trang đầu";
		pagination._intl.getRangeLabel = (
			page: number,
			pageSize: number,
			length: number
		) => {
			if (length == 0 || pageSize == 0) {
				return `0 trong tổng ${length}`;
			}

			length = Math.max(length, 0);

			const startIndex = page * pageSize;

			// If the start index exceeds the list length, do not try and fix the end index to the end.
			const endIndex =
				startIndex < length
					? Math.min(startIndex + pageSize, length)
					: startIndex + pageSize;

			return `${startIndex + 1} - ${endIndex} trong tổng số ${length}`;
		};
		pagination._intl.itemsPerPageLabel = "Số dòng trên trang";
		pagination._intl.lastPageLabel = "Trang cuối";
		pagination._intl.nextPageLabel = "Trang kế";
		pagination._intl.previousPageLabel = "Trang trước";
	}

	setUpPaginationLabelsForecastReport(pagination: MatPaginator) {
		pagination._intl.firstPageLabel = "Trang đầu";
		pagination._intl.getRangeLabel = (
			page: number,
			pageSize: number,
			length: number
		) => {
			if (length == 0 || pageSize == 0) {
				return `0 trong tổng ${length}`;
			}

			length = Math.max(length, 0);

			const startIndex = page * pageSize;

			// If the start index exceeds the list length, do not try and fix the end index to the end.
			const endIndex =
				startIndex < length
					? Math.min(startIndex + pageSize, length)
					: startIndex + pageSize;

			return `${startIndex + 1} - ${endIndex} trong tổng số ${length}`;
		};
		pagination._intl.itemsPerPageLabel = "Số PO trên trang";
		pagination._intl.lastPageLabel = "Trang cuối";
		pagination._intl.nextPageLabel = "Trang kế";
		pagination._intl.previousPageLabel = "Trang trước";
	}

	POP01(sophieu: string = "") {
		var title = "Xác nhận";
		var description = "Bạn chắc chắn xóa phiếu " + sophieu + " ?";
		return this.dialog.open(PopUpComponent, {
			data: { title, description },
			width: "440px",
		});
	}

	POP02(sophieu: string = "") {
		var title = "Xác nhận";
		var description = "Bạn chắc chắn thông tin phiếu " + sophieu + " ?";
		return this.dialog.open(PopUpComponent, {
			data: { title, description },
			width: "440px",
		});
	}

	POP03(sophieu: string = "") {
		var title = "Xác nhận";
		var description = "Bạn chắc chắn kết quả duyệt phiếu " + sophieu + " ?";
		return this.dialog.open(PopUpComponent, {
			data: { title, description },
			width: "440px",
		});
	}

	POP04(sophieu: string = "") {
		var title = "Xác nhận";
		var description = "Bạn chắc chắn hủy phiếu " + sophieu + " ?";
		return this.dialog.open(PopUpComponent, {
			data: { title, description },
			width: "440px",
		});
	}
	POP05(sophieu: string = "") {
		var title = "Xác nhận";
		var description = "Bạn chắc chắn gửi phiếu " + sophieu + " về để xử lý lại ?";
		return this.dialog.open(PopUpComponent, {
			data: { title, description },
			width: "440px",
		});
	}
	POP07(hangHoa: string = "") {
		var title = "Xác nhận";
		var description = "Bạn chắc chắn xóa hàng hóa " + hangHoa + " ?";
		return this.dialog.open(PopUpComponent, {
			data: { title, description },
			width: "440px",
		});
	}
	POPConfirm(text: string = "") {
		var title = "Xác nhận";
		var description = text
			? text
			: "Việc thay đổi sẽ mất dữ liệu hiện có. Bạn chắc chắn muốn thay đổi?";
		return this.dialog.open(PopUpComponent, {
			data: { title, description },
			width: "440px",
		});
	}

	showInfo(message) {
		let action = "";
		this.snackBar.open(message, action, {
			duration: 3000,
		});
	}

	showInfoInfinity(message) {
		let action = "Ẩn";
		this.snackBar.open(message, action, {
			duration: undefined,
			panelClass: ["mat-toolbar", "mat-info"],
		});
	}

	showErorr(message) {
		let action = "Đã hiểu";
		this.snackBar.open(message, action, {
			duration: undefined,
			panelClass: ["mat-toolbar", "mat-warn"],
		});
	}

	POPHuongXuLy(
		enableNhapKho: boolean = false,
		enableXuatKho: boolean = false
	) {
		return this.dialog.open(PopUpHuongXuLyComponent, {
			data: { enableNhapKho, enableXuatKho },
			width: "440px",
		});
	}

	// popup chỉ dành cho danh mục
	POP01_DanhMuc() {
		var title = "Xác nhận";
		var description = "Bạn chắc chắn xóa " + " ?";
		return this.dialog.open(PopUpComponent, {
			data: { title, description },
			width: "440px",
		});
	}

	POP02_DanhMuc() {
		var title = "Xác nhận";
		var description = "Bạn chắc chắn thông tin ?";
		return this.dialog.open(PopUpComponent, {
			data: { title, description },
			width: "440px",
		});
	}

	POP04_DanhMuc() {
		var title = "Xác nhận";
		var description = "Bạn chắc chắn hủy" + " ?";
		return this.dialog.open(PopUpComponent, {
			data: { title, description },
			width: "440px",
		});
	}
	// end

	//popup chỉ dành cho kế toán
	POP_GhiSo(sophieu: string = "") {
		var title = "Xác nhận";
		var description = "Bạn chắc chắn ghi sổ phiếu " + sophieu + " ?";
		return this.dialog.open(PopUpComponent, {
			data: { title, description },
			width: "440px",
		});
	}
	POP_BoGhiSo(sophieu: string = "") {
		var title = "Xác nhận";
		var description = "Bạn chắc chắn bỏ ghi sổ phiếu " + sophieu + " ?";
		return this.dialog.open(PopUpComponent, {
			data: { title, description },
			width: "440px",
		});
	}
	POP_XoaPhieu(sophieu: string = "") {
		var title = "Phiếu đã ghi sổ";
		var description =
			"Phiếu " + sophieu + " đã ghi sổ, bạn chắc chắn muốn xoá ?";
		return this.dialog.open(PopUpComponent, {
			data: { title, description },
			width: "440px",
		});
	}
	POP_ChungTuChuaGhiSo(soluongchungtu: number) {
		var title = "Xác nhận";
		var description = `Có ${soluongchungtu} chứng từ chưa ghi sổ. Muốn thực hiện khóa sổ, bạn phải xử lý các chứng
		từ này.Bạn có muốn tiếp tục không?
		`;
		return this.dialog.open(PopUpComponent, {
			data: { title, description },
			width: "440px",
		});
	}
	POP_DaTonTaiTinhGiaThanh(FromDay: string, ToDay: string) {
		var title = "Xác nhận";
		var description = `Đã tồn tại bảng tính giá thành sản xuất liên tục giản đơn của kỳ tính giá thành "Kỳ tính giá thành
		từ ngày ${FromDay} đến ngày ${ToDay}" . Bạn có muốn tính giá không?
		`;
		return this.dialog.open(PopUpComponent, {
			data: { title, description },
			width: "440px",
		});
	}
	POP_DaTonTaiKetChuyenChiPhi(FromDay: string, ToDay: string) {
		var title = "Xác nhận";
		var description = `Đã tồn tại chứng từ kết chuyển chi phí của kỳ tính giá thành "Kỳ tính giá thành
		từ ngày ${FromDay} đến ngày ${ToDay}" . Bạn có muốn xem chứng từ này không?
		`;
		return this.dialog.open(PopUpComponent, {
			data: { title, description },
			width: "440px",
		});
	}
	//end
	POP_XoaChungTuLienQuan(description: string) {
		var title = "Xác nhận";

		return this.dialog.open(PopUpComponent, {
			data: { title, description },
			width: "440px",
		});
	}
	POP_XacNhan(description: string) {
		var title = "Xác nhận";

		return this.dialog.open(PopUpComponent, {
			data: { title, description },
			width: "440px",
		});
	}
	WarningOffAutoRun(
		_title: string = "",
		_description: string = "",
		_btnLeft: string = "",
		_btnRight: string = ""
	) {
		var title = _title;
		var description = _description;
		var btnLeft = _btnLeft;
		var btnRight = _btnRight;
		return this.dialog.open(PopUpComponent, {
			data: { title, description, btnLeft, btnRight },
			width: "440px",
		});
	}

	openSnackBar() {
		this.snackBar.open("Bạn có lịch xuất hàng bán cần xác nhận!", "Xem chi tiết", {
			horizontalPosition: 'right',
			verticalPosition: 'bottom',
			duration: undefined
		})
			.onAction()
			.subscribe(() => this.router.navigateByUrl('/lich-xuat-hang-ban'));;
	}

	remindDeliveryPlan(_routerLink: string = "/lich-xuat-hang-ban") {
		const _data = {
			snackBar: this.snackBar,
			routerLink: _routerLink,
			router: this.router
		}
		return this.snackBar.openFromComponent(RemindDeliveryPlanComponent, {
			horizontalPosition: 'right',
			verticalPosition: 'bottom',
			data: _data,
		});
	}

	resultBOMImport(res) {
		return this.dialog.open(BOMImportResultComponent, {
			data: res,
			width: "45%",
		});
	}
	// .. Dialog kết quả import đề nghị xuất kho
	warningImportDNXK(res) {
		return this.dialog.open(KhoDeNghiXuatKhoImportWarningtComponent, {
			data: res,
			width: "40%",
		});
	}

	timePickerPopup(time, alertTimeBefore) {
		return this.dialog.open(
			TimePickerPopupComponent, {
			data: { time, alertTimeBefore },
			width: "440px",
		}

		)
	}
}
